import { configureStore } from '@reduxjs/toolkit';
import contestantsSlice from '../features/contestants/contestantsSlice';
import comfortDareSlice from '../features/comfort/comfortDare/comfortDareSlice';
import comfortLightDareSlice from '../features/comfort/comfortLightDare/comfortLightDareSlice';
import comfortTrueSlice from '../features/comfort/comfortTrue/comfortTrueSlice';
import exploreTrueSlice from '../features/explore/exploreTrue/exploreTrueSlice';
import accessoriesSlice from '../features/accessories/accessoriesSlice';
import gameStatusSlice from '../features/gamesStatus/gameStatusSlice';
import exploreDareSlice from '../features/explore/exploreDare/exploreDareSlice';
import openTrueSlice from '../features/open/openTrue/openTrueSlice';
import openDareSlice from '../features/open/openDare/openDareSlice';
import openLightDareSlice from '../features/open/openLightDare/openLightDareSlice';
import openKinkyDareSlice from '../features/open/openKinkyDare/openKinkyDareSlice';
import { loadState, saveState } from '../features/localStorage/localStorage';
import { loadFromSessionStorage, saveToSessionStorage } from '../features/sessionStorage/sessionStorage';
import  demoDareSlice  from '../features/demo/demoDare/demoDareSlice';
import  demoTrueSlice  from '../features/demo/demoTrue/demoTrueSlice';
import  demoLightDareSlice  from '../features/demo/demoLightDare/demoLightDareSlice';



const persistedState = loadState();

const store = configureStore({
  reducer: {
    contestants: contestantsSlice,
    demoDare: demoDareSlice,
    demoLightDare: demoLightDareSlice,
    demoTrue: demoTrueSlice,
    exploreTrue: exploreTrueSlice,
    exploreDare: exploreDareSlice,
    comfortTrue: comfortTrueSlice,
    comfortDare: comfortDareSlice,
    comfortLightDare: comfortLightDareSlice,
    openTrue: openTrueSlice,
    openDare: openDareSlice,
    openLightDare: openLightDareSlice,
    openKinkyDare: openKinkyDareSlice,
    accessories: accessoriesSlice,
    gameStatus: gameStatusSlice,
    
  },
  preloadedState: persistedState

});
store.subscribe(() => {
  saveState(store.getState());
});

export default store;